export default {
    mainTitle: '运维分析报告',
    startTimeTitle: '开始时间：',
    electricity: '电能报告分析',
    startTimeDefault: '请选择开始时间',
    endTimeTitle: '结束时间：',
    endTimeDefault: '请选择结束时间',
    projnameTitle: '项目名称：',
    projnameDefault: '请选择项目',
    projtypeTitle: '报表类型：',
    projtypeDefault: '请选择报表类型',
    classifyDefault: '请选择报表分类',
    projtypeHeader: '报表类型',
    projgentimeHeader: '报表生成时间',
    operationHeader: '操作',
    resetbtn: '重置',
    querybtn: '查询',
    classify: '报表分类'
}



// WEBPACK FOOTER //
// ./src/config/i18n/zh-cn/opsReportAnalysis.js